  import React,{ useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { getRefundPrice } from "redux/actions/UserCustomerTrip";
import CancelRefund from "./CancelRefund";
import { enumValue } from "utils/enumObject";
import CommonDialog from "components/commonDialog/CommonDialog";


 function CancelReason(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] =useState(props?.openDialog);
  const [value, setValue] = useState('');
  const [cancelRefund, setCancelRefund] = useState(false);
  const dispatch = useDispatch();
  const refundPriceData = useSelector((state) => state.userRefundPrice?.userRefundPrice?.data)

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setValue(enumValue?.zero);
    props?.handleClose(open);

  };
  const handleCancelRefund = () =>{
    setOpen(false);
    setCancelRefund(true)
  }
  useEffect(() =>{
    const refundPayload = {
      id:props?.tripId
    }
    dispatch(getRefundPrice(refundPayload))
  },[])
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <div>
      <CommonDialog 
      open={open}
      handleClose={handleClose}
      value={value}
      handleChange={handleChange}
      handleCancelRefund={handleCancelRefund}
      cancelReasonData={props?.cancelReasonData}
      cancelReason={true}
      />
      {cancelRefund && <CancelRefund 
      handleClickOpen={handleClickOpen}
      reason={value}
      tripId={props?.tripId}
      handleClose={handleClose}
      refundPriceData={refundPriceData}
      cancelRefund={cancelRefund}/>}
    </div>
  );
}
export default CancelReason;
